const EmbeddedVideoPlayer = (el) => {

    const playButton = el.querySelector('.embedded-video-player__cover');
    const video = el.querySelector('.embedded-video-player__embedded');
    const label = el.querySelector('.embedded-video-player__label');

    playButton.addEventListener('click', playVideo);
    el.addEventListener('keydown', function (event) {
        if (el.activeElement !== playButton && el.activeElement !== video) return;
        if ((event.key === ' ' || event.key === 'Enter')) {
            event.preventDefault(); // Prevent scrolling when pressing Space
            playVideo();
            video.focus();
        }
    });

    function playVideo() {
        console.log({ video });
        playButton.classList.add('h-hidden');
        label.classList.add('h-hidden');
        video.setAttribute('controls', 'controls');
        video.play();
    }
};

export default EmbeddedVideoPlayer;
